function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#C21313",
  fillRule: "evenodd",
  d: "M13.894 3.068c.067.07.65.713.603 1.88-.107 1.202-.617 1.966-.996 2.506.415 1.15.017 2.751-.794 3.636C10.715 13.264 8.44 14 6.462 14c-2.457 0-4.457-1.134-4.895-2.061-.185-.39.024-.43.513-.43l.43.002c1.405 0 4.078-.202 6.72-4.142.515-.768 1.46-1.243 2.35-1.243.348 0 .689.073.992.23.28-.386.61-.91.589-1.469.02-.52-.198-.792-.2-.794a.75.75 0 01-.013-1.012.638.638 0 01.946-.013zM5.668 6.782C3.324 8.444 4.295 9.146 4.6 9.62c-1.98-.133-2.868-1.645-2.21-2.28 2.16-2.084 1.82-3.873 1.316-4.873a.312.312 0 01.074-.376.369.369 0 01.405-.055c1.306.63 3.317 2.047 3.149 4.737-.059.933-.628 1.898-1.438 2.488-1.117-.942-.227-2.48-.227-2.48z"
});

function SvgPeper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgPeper;